import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'element-react'
import { withRouter } from 'react-router'
import AppRoutes from '../../routes/appRoutes'

const SearchForm = props => {
    const [query, setQuery] = useState('')

    const handleSubmit = ev => {
        ev.preventDefault()
        if (query != '') {
            props.history.push({
                pathname: AppRoutes.adminSearch(),
                search: '?query=' + query,
            })
        } else {
            props.history.push({
                pathname: '/admin',
            })
        }
    }

    return (
        <form method="GET" onSubmit={handleSubmit}>
            <Input
                className="search el-append-button-header"
                placeholder="Find a user or customer"
                name="query"
                value={query}
                onChange={setQuery}
                append={
                    <Button type="default" onClick={handleSubmit}>
                        Search
                    </Button>
                }
            />
        </form>
    )
}

SearchForm.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }),
}

const RoutedForm = withRouter(SearchForm)

export default RoutedForm
